var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "212",
      "height": "185",
      "viewBox": "0 0 212 185",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M173.335 18.0353L168.479 20.359C167.137 21.0008 165.53 20.4339 164.888 19.0925C164.247 17.751 164.814 16.144 166.155 15.5022L171.012 13.1785C172.353 12.5367 173.96 13.1036 174.602 14.445C175.244 15.7865 174.677 17.3935 173.335 18.0353Z",
      "fill": "#ED6400"
    }
  }), _c('path', {
    attrs: {
      "d": "M165.333 27.3238C165.827 25.9221 167.365 25.1864 168.767 25.6808L173.844 27.4722C175.246 27.9671 175.982 29.5045 175.487 30.9066C174.992 32.3084 173.455 33.0441 172.053 32.5496L166.976 30.7582C165.574 30.2636 164.838 28.7263 165.333 27.3238Z",
      "fill": "#ED6400"
    }
  }), _c('path', {
    attrs: {
      "d": "M158.76 13.5872C160.162 14.0815 161.699 13.3458 162.194 11.9442L163.985 6.86673C164.479 5.46429 163.744 3.92695 162.341 3.43233C160.94 2.93803 159.402 3.67372 158.907 5.07535L157.117 10.1528C156.622 11.5549 157.357 13.0922 158.76 13.5872Z",
      "fill": "#ED6400"
    }
  }), _c('path', {
    attrs: {
      "d": "M10.3929 171.475L15.2663 169.186C16.6123 168.554 17.1907 166.951 16.5585 165.605C15.9263 164.259 14.3234 163.68 12.9774 164.312L8.10408 166.601C6.75807 167.233 6.17966 168.836 6.81184 170.182C7.44403 171.528 9.04692 172.107 10.3929 171.475Z",
      "fill": "#ED6400"
    }
  }), _c('path', {
    attrs: {
      "d": "M22.6487 171.158C21.2504 170.654 19.7075 171.378 19.203 172.776L17.3757 177.841C16.8712 179.24 17.5957 180.782 18.9943 181.287C20.3926 181.791 21.9355 181.067 22.44 179.669L24.2673 174.604C24.7719 173.206 24.0474 171.663 22.6487 171.158Z",
      "fill": "#ED6400"
    }
  }), _c('path', {
    attrs: {
      "d": "M16.1748 157.374C15.67 158.773 14.1271 159.497 12.7291 158.993L7.6648 157.165C6.26611 156.66 5.54162 155.118 6.04628 153.719C6.55109 152.321 8.09398 151.596 9.49204 152.101L14.5563 153.928C15.9549 154.433 16.6794 155.976 16.1748 157.374Z",
      "fill": "#ED6400"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#clip0_3996_48158)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M117.982 99.3014C117.982 97.9545 116.89 96.8633 115.543 96.8633H63.528C62.181 96.8633 61.0898 97.9548 61.0898 99.3014C61.0898 100.648 62.181 101.74 63.528 101.74H115.543C116.89 101.74 117.982 100.648 117.982 99.3014Z",
      "fill": "#07B53B"
    }
  }), _c('path', {
    attrs: {
      "d": "M127.896 153.428C129.575 155.668 132.249 157.004 135.048 157.004C137.847 157.004 140.521 155.668 142.2 153.428L176.335 107.915C179.293 103.972 178.491 98.3571 174.547 95.3987C170.603 92.4415 164.988 93.2434 162.031 97.1872L160.242 99.5716V31.0299C160.242 26.1005 156.232 22.0898 151.302 22.0898H47.2727C42.3427 22.0898 38.3323 26.1005 38.3323 31.0299V31.8427H32.6432C27.7135 31.8427 23.7031 35.8534 23.7031 40.7828V157.817C23.7031 162.746 27.7135 166.757 32.6432 166.757H38.3323V167.57C38.3323 172.499 42.3427 176.51 47.2724 176.51H151.302C156.231 176.51 160.242 172.499 160.242 167.57V141.562C160.242 140.215 159.151 139.124 157.804 139.124C156.457 139.124 155.366 140.215 155.366 141.562V167.57C155.366 169.811 153.543 171.634 151.302 171.634H47.2727C45.0318 171.634 43.2089 169.811 43.2089 167.57V63.5396C43.2089 62.1926 42.1174 61.1014 40.7708 61.1014C39.4241 61.1014 38.3326 62.1929 38.3326 63.5396V161.881H32.6432C30.4023 161.881 28.5794 160.058 28.5794 157.817V40.7828C28.5794 38.5419 30.4023 36.719 32.6432 36.719H38.3323V53.7864C38.3323 55.1333 39.4238 56.2245 40.7705 56.2245C42.1171 56.2245 43.2086 55.133 43.2086 53.7864V31.0299C43.2086 28.789 45.0315 26.9661 47.2724 26.9661H151.302C153.543 26.9661 155.366 28.789 155.366 31.0299V105.802C155.366 105.888 155.37 105.972 155.379 106.056L135.048 133.164L127.571 123.195C126.139 121.284 124.047 120.046 121.683 119.708C119.318 119.371 116.965 119.974 115.055 121.407C113.144 122.839 111.906 124.931 111.569 127.295C111.231 129.659 111.834 132.013 113.267 133.923L127.896 153.428ZM116.396 127.984C116.55 126.91 117.112 125.959 117.981 125.308C118.692 124.774 119.537 124.494 120.41 124.494C120.604 124.494 120.798 124.508 120.993 124.536C122.068 124.69 123.018 125.252 123.67 126.121L133.097 138.691C133.558 139.305 134.281 139.667 135.048 139.667C135.815 139.667 136.538 139.305 136.998 138.691L165.932 100.113C167.276 98.32 169.829 97.9559 171.621 99.3002C173.413 100.645 173.778 103.197 172.434 104.989L138.299 150.503C137.535 151.52 136.32 152.128 135.048 152.128C133.776 152.128 132.561 151.52 131.797 150.503L117.168 130.997C116.517 130.129 116.242 129.059 116.396 127.984Z",
      "fill": "#07B53B"
    }
  }), _c('path', {
    attrs: {
      "d": "M63.3913 64.3516C62.0443 64.3516 60.9531 65.4428 60.9531 66.7897C60.9531 68.1367 62.0443 69.2279 63.3913 69.2279H99.1519C100.499 69.2279 101.59 68.1367 101.59 66.7897C101.59 65.4428 100.499 64.3516 99.1519 64.3516H63.3913Z",
      "fill": "#ED6400"
    }
  }), _c('path', {
    attrs: {
      "d": "M63.528 88.7318H115.543C116.89 88.7318 117.981 87.6403 117.981 86.2936C117.981 84.947 116.89 83.8555 115.543 83.8555H63.528C62.181 83.8555 61.0898 84.947 61.0898 86.2936C61.0898 87.6403 62.1813 88.7318 63.528 88.7318Z",
      "fill": "#07B53B"
    }
  }), _c('path', {
    attrs: {
      "d": "M135.049 51.3477H63.528C62.181 51.3477 61.0898 52.4389 61.0898 53.7858C61.0898 55.1328 62.181 56.224 63.528 56.224H135.049C136.396 56.224 137.487 55.1328 137.487 53.7858C137.487 52.4389 136.395 51.3477 135.049 51.3477Z",
      "fill": "#ED6400"
    }
  })]), _c('circle', {
    attrs: {
      "cx": "191.535",
      "cy": "64.2418",
      "r": "6.63636",
      "fill": "#ED6400"
    }
  }), _c('circle', {
    attrs: {
      "cx": "205.29",
      "cy": "104.598",
      "r": "4.8412",
      "stroke": "#07B53B",
      "stroke-width": "2.70912"
    }
  }), _c('circle', {
    attrs: {
      "cx": "2.32976",
      "cy": "75.2087",
      "r": "2.32976",
      "fill": "#07B53B"
    }
  }), _c('ellipse', {
    attrs: {
      "rx": "3.38641",
      "ry": "3.72505",
      "transform": "matrix(1 0 0 -1 188.285 132.447)",
      "fill": "#07B53B"
    }
  }), _c('circle', {
    attrs: {
      "cx": "5.42006",
      "cy": "125.334",
      "r": "2.70912",
      "fill": "#ED6400"
    }
  }), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_3996_48158"
    }
  }, [_c('rect', {
    attrs: {
      "width": "154.42",
      "height": "154.42",
      "fill": "white",
      "transform": "translate(23.7031 22.0859)"
    }
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }